module.exports = __webpack_public_path__ + "img/manda_011.8a47e035.png";